import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';

const StudentSelectorItem = (props) => {
  const { student, selected, onToggle } = props;

  const handleToggle = useCallback(() => {
    onToggle(student);
  }, [student, onToggle]);

  return (
    <>
      <ListItem role={undefined} disableGutters dense button onClick={handleToggle}>
        <Checkbox checked={selected} tabIndex={-1} disableRipple color="secondary" />
        <ListItemText primary={student.name} secondary={student.group ? student.group.name : ''} />
      </ListItem>
      <Divider />
    </>
  );
};

StudentSelectorItem.propTypes = {
  student: PropTypes.object,
  selected: PropTypes.bool,

  onToggle: PropTypes.func.isRequired,
};

StudentSelectorItem.defaultProps = {
  student: {},
  selected: false,
};

export default StudentSelectorItem;
